import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Sua conta está em análise',
  description:
    'Você já pode criar rascunhos. O envio para análise libera depois da aprovação, que chega por e-mail e aparece aqui.',
  reviewData: 'Revisar dados enviados',
} satisfies TranslationTree;
